import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectEstateTypeFilter } from 'shared/selectors/advancedFilters';
import { EEstateType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const EstateTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectEstateTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleEstateTypeChange = useCallback(
    (newValue: NonEmptyArray<EEstateType> | null) => {
      onChange({ action: 'setEstateType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleEstateTypeChange} />
    </AdvancedFilterRow>
  );
};
